export default __webpack_public_path__ + "static/media/keyvisual-neuss.a048342e.jpg";